export enum PanelType {
  PANEL = 'panel',
  AGENT = 'admin',
  WRITER = 'writer',
  WEB = 'web'
}
